import { render, staticRenderFns } from "./YiXinApplication.vue?vue&type=template&id=a6ee6320&scoped=true"
import script from "./YiXinApplication.vue?vue&type=script&lang=js"
export * from "./YiXinApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ee6320",
  null
  
)

export default component.exports